// load styles
require('./main-style.less');
// load configs
require('./app.config');

// load modules
require('./layout');

var ngSentry = require('./common/sentry-service.js');

angular.module('bbl', [
    'bbl.config',
    ngSentry,
    'ngSanitize',
    'pascalprecht.translate',
    'ngRoute',
    'ngCookies',
    'dndLists',

    'bbl.services',

    'bbl.interceptors',
    'bbl.common',
    'bbl.layout',
    'bbl.authorization',
    'bbl.support',

    'bbl.modules',
    'bbl.directives'
  ])

  .config(['$locationProvider', '$routeProvider', '$httpProvider', '$qProvider', function($locationProvider, $routeProvider, $httpProvider, $qProvider) {
    $locationProvider.hashPrefix('');
    $routeProvider.otherwise({redirectTo: '/dashboard'});
    $httpProvider.interceptors.push('AuthInterceptor');
    $qProvider.errorOnUnhandledRejections(false);
  }])

  .config(['$translateProvider', function ($translateProvider) {
    // add translation table
    Object.keys({en: []}).forEach(function(ln) {
      $translateProvider.translations(ln, []);
    });

    $translateProvider
      .useSanitizeValueStrategy('escape')
      .useCookieStorage()

      .useStaticFilesLoader({
        prefix: 'https://s3.amazonaws.com/bblmisc/localization/',
        // prefix: '/assets/locales/locale-',
        suffix: '.json'
      })

      .registerAvailableLanguageKeys(['en', 'es', 'pt'], {
        'en*': 'en',
        'es*': 'es',
        'pt*': 'pt',
        '*': 'en',
      })

      // determine the user language
      .determinePreferredLanguage();
  }])

  .run(require('./app-run'));

require('./common').inject();
require('./authorization').load();
require('./support').load();
require('./modules');



/*****************
 ** WEBPACK FOOTER
 ** ./app/app.js
 ** module id = 0
 ** module chunks = 0
 **/